import React, { Component } from "react"
import config from "react-global-configuration"
import OutsideClickTrigger from "../common/OutsideClickTrigger"
import * as cookieHelper from "../../../helpers/cookie"

class ParkingExtraServicesSelectorModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedCategoryName: undefined,
      mobileSeletionExpanded: false,
      isCarTypeSelectorOpen: false,
    }
  }

  componentDidUpdate(prevState) {
    if (prevState.isCarTypeSelectorOpen !== this.state.isCarTypeSelectorOpen) {
      if (this.state.isCarTypeSelectorOpen) this.trackCarTypeSelector()
    }
  }
  trackCarTypeSelector = () => {
    const { booking } = this.props.bookingResult
    const userId = cookieHelper.getUserId(this.props)
    const data = {
      event: "track-event",
      eventCategory: "parking flow",
      eventAction: "extra services",
      eventLabel: "car type: open",
      eventValue: 0,
      eventNoninteraction: true,
      userParkingArrivalDate: booking.arrivalDate,
      userParkingDepartureDate: booking.departureDate,
      pageBusinessunit: "parking",
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }

  trackSelectedCategory = (label) => {
    const { booking } = this.props.bookingResult
    const userId = cookieHelper.getUserId(this.props)
    const data = {
      event: "track-event",
      eventCategory: "parking flow",
      eventAction: "extra services",
      eventLabel: `car type: select - ${label}`,
      eventValue: 0,
      eventNoninteraction: true,
      userParkingArrivalDate: booking.arrivalDate,
      userParkingDepartureDate: booking.departureDate,
      pageBusinessunit: "parking",
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }
  trackReserve = (offer) => {
    const { booking } = this.props.bookingResult
    const userId = cookieHelper.getUserId(this.props)
    const data = {
      event: "track-event",
      eventCategory: "parking flow",
      eventAction: "extra services",
      eventLabel: `reserve - ${offer.name}`,
      eventValue: 0,
      eventNoninteraction: true,
      userParkingArrivalDate: booking.arrivalDate,
      userParkingDepartureDate: booking.departureDate,
      pageBusinessunit: "parking",
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }

  categoryChangeHandler = (evt) => {
    console.debug(evt.target.value)
    this.setState({
      selectedCategoryName: evt.target.value,
    })
    this.trackSelectedCategory(evt.target.value)
  }

  // handleSelectorToggle = () => {
  //     this.refs.carTypeSelector
  // }

  handleReserveExtra = (product, offer) => {
    this.trackReserve(offer)

    this.props.extraServiceModalSelectorToogle(this.props.extraProduct)
    this.props.extraServicesAcceptConditionsModalActivate(
      product,
      offer,
      true,
      // ,() => this.props.history.push({pathname: path.CHECKOUT(), search:this.props.location.search} )
    )
  }

  renderCarserviceOption = (option, index) => {
    const business = option.carTypes.find((type) => type.name === "Business")
    const exclusive = option.carTypes.find((type) => type.name === "Exclusive")
    const firtClass = option.carTypes.find((type) => type.name === "FirstClass")
    return (
      <div className="car-wash-features__table__row" key={index}>
        <div className="car-wash-features__table__col car-wash-features__table__col--name">{option.serviceName}</div>
        <div className="car-wash-features__table__col car-wash-features__table__col--product">
          {business.isIncluded ? (
            <svg className="svg-icon svg-icon--checkmark">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                &nbsp;
              </use>
            </svg>
          ) : null}
        </div>
        <div className="car-wash-features__table__col car-wash-features__table__col--product">
          {exclusive.isIncluded ? (
            <svg className="svg-icon svg-icon--checkmark">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                &nbsp;
              </use>
            </svg>
          ) : null}
        </div>
        <div className="car-wash-features__table__col car-wash-features__table__col--product">
          {firtClass.isIncluded ? (
            <svg className="svg-icon svg-icon--checkmark">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                &nbsp;
              </use>
            </svg>
          ) : null}
        </div>
      </div>
    )
  }

  render() {
    const { extraProduct } = this.props
    const textKeys = config.get("textKeys.extraServices.selectorModal") || {}
    if (!this.props.isActive || !extraProduct) return ""

    let carWash = this.props.bookingExtrasConfiguration.extraServices.find((e) => e.id === extraProduct.id)
    carWash.categories = carWash.categories.filter((c) => c.type !== "2020 services") // do not include new service offerings in old dialogue
    const carWashFeatures = this.props.bookingExtrasConfiguration.Options[carWash.extraProductCode]
    const categoryNames = carWash && carWash.categories.map((c) => c.type)

    const selectedCategoryName = this.state.selectedCategoryName || carWash.categories[0].type
    const currentCategory = carWash.categories.find((c) => c.type === selectedCategoryName)
    const offersForSelectedCategory = extraProduct.offerLines.filter((o) => Object.values(currentCategory.offerLineIds).find((s) => s === o.id))

    return (
      <OutsideClickTrigger onOutsideClick={() => this.props.extraServiceModalSelectorToogle(this.props.extraProduct)}>
        <div className="overlay overlay--modal overlay--fixed is-active">
          <div className="modal modal--takeover modal--white">
            <button
              className="button button--icon js--close-modal"
              onClick={() => this.props.extraServiceModalSelectorToogle(this.props.extraProduct)}
            >
              <span className="icon">
                <svg className="svg-icon svg-icon--close-new">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                    &nbsp;
                  </use>
                </svg>
              </span>
            </button>
            <div className="modal__content modal__content--no-padding">
              <div className="modal__content__inner">
                <div className="modal__middle">
                  <div className="car-wash-features">
                    <header className="car-wash-features__header">
                      <div className="w--wider">
                        <h6>{extraProduct && extraProduct.dynamicFields && extraProduct.dynamicFields.productName}</h6>
                        <h3>{textKeys.choose || "Vælg variant"}</h3>
                        <div className="js--accordion is-bound" data-disposable="true">
                          {this.state.mobileSeletionExpanded ? null : (
                            <button className="js--accordion-trigger" onClick={() => this.setState({ mobileSeletionExpanded: true })}>
                              <p>
                                {textKeys.carType || "Biltype:"} {selectedCategoryName}{" "}
                                <span className="link">{textKeys.changeCarType || "Skift"}</span>
                              </p>
                            </button>
                          )}
                          <div className="js--accordion-content" style={{ maxHeight: this.state.mobileSeletionExpanded ? "none" : "0px" }}>
                            <div className="form__section form__section--no-border form__section--light">
                              <div className="form__section__inner">
                                <div className="form__field form__field--select  is-filled">
                                  <div className="form__container">
                                    <span className="form__valid" />
                                    <select
                                      id="select"
                                      className="form__item "
                                      aria-label="Select menu"
                                      tabIndex="1"
                                      defaultValue={selectedCategoryName}
                                      onChange={this.categoryChangeHandler}
                                      onClick={() => this.setState({ isCarTypeSelectorOpen: !this.state.isCarTypeSelectorOpen })}
                                    >
                                      {categoryNames.map((c) => {
                                        return (
                                          <option value={c} key={c}>
                                            {c}
                                          </option>
                                        )
                                      })}
                                    </select>
                                    <label htmlFor="select" className="form__label">
                                      <span className="form__label__text">
                                        {textKeys.carTypeLabel || "Din biltype"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </header>
                    <div className="w--wider">
                      <div className="car-wash-features__table">
                        <header className="car-wash-features__table__header">
                          <div className="car-wash-features__table__row">
                            <div className="car-wash-features__table__col car-wash-features__table__col--name">&nbsp;</div>

                            {offersForSelectedCategory.map((offer) => {
                              return (
                                <div className="car-wash-features__table__col car-wash-features__table__col--product" key={offer.id}>
                                  <p>{offer.name}</p>
                                  <h4>{this.props.priceFormatter(offer.totalPricePerUnit)}</h4>
                                  {offer.active ? (
                                    <button
                                      className="button button--small button--general"
                                      onClick={() => this.handleReserveExtra(extraProduct, offer)}
                                    >
                                      <span className="number">{this.props.priceFormatter(offer.totalPricePerUnit)}</span>
                                      <span className="text">{textKeys.button || "Reservér"}</span>
                                    </button>
                                  ) : (
                                    <button className="button button--small button--general is-disabled">
                                      <span className="number">{this.props.priceFormatter(offer.totalPricePerUnit)}</span>
                                      <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
                                    </button>
                                  )}
                                </div>
                              )
                            })}
                          </div>
                        </header>
                        <div className="car-wash-features__table__body">
                          {carWashFeatures.map((option, index) => this.renderCarserviceOption(option, index))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </OutsideClickTrigger>
    )
  }
}
export default ParkingExtraServicesSelectorModal
